import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

//Need this import for Bootstrap to work
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById('root')
);

